import React, { useState } from 'react';
import './servicefaq.css';

function ServiceFAQ() {
    // Track which items are open (array of indexes)
    const [activeIndexes, setActiveIndexes] = useState([0, 9]); // first of each group open by default

    // Helper to toggle an item
    const handleToggle = (idx) => {
        setActiveIndexes((prev) =>
            prev.includes(idx)
                ? prev.filter(i => i !== idx)
                : [...prev, idx]
        );
    };

    // FAQ data (combine both groups for simplicity)
    const faqData = [
        {
            question: "What are the different Service Opportunities?",
            answer: <>Sathya Sai Service Opportunities are rooted in the guiding principles of <strong>“Love All, Serve All”</strong> and <strong>“Help Ever, Hurt Never.”</strong></>
        },
        {
            question: "What is Selfless Service?",
            answer: "Service is performed as an offering to God, with the spiritual goal of removing ego and developing compassion in the caregiver and recipient. Service is not performed for personal gain or recognition."
        },
        {
            question: "What is Community-Focused Service?",
            answer: "Sathya Sai Center Milwaukee works to serve the needs of the community, particularly focusing on the less privileged."
        },
        {
            question: "Does Sathya Sai Center Milwaukee work on Environmental Projects?",
            answer: "In year 2025, planted 200 trees in the community as part of the global initiative to plant 1 million trees."
        },
        {
            question: "Service for the Elderly and Vulnerable Care?",
            answer: "Sathya Sai Center Milwaukee adult and SSE Students visit local nursing homes to spend time with the elderly and vulnerable, playing music and games."
        },
        {
            question: "Are there Opportunities for Medical & Humanitarian Aid?",
            answer: "Sathya Sai Center Milwaukee has organized blood donation drives. In 2025, 26 units of blood were donated to the local blood bank."
        },
        {
            question: "Is there Educational Initiatives for Tutoring?",
            answer: "Our SSE students from group 4 help students by tutoring and assisting complete their homework."
        },
        {
            question: "Can any body join or volunteer?",
            answer: "Following the guiding principle of \"Help Ever, Hurt Never\", anyone can join and volunteer in our service activities."
        },
        {
            question: "What are the common services Sathya Sai Milwaukee Center volunteer?",
            answer: "There are a couple of volunteer activities such as \"Preparing Sandwiches\", \"Blood Drive\", \"Elderly Nursing Home\", \"Teaching Music\", \"Beanie Project\"."
        },
        {
            question: "Is there more I can read about service activity?",
            answer: <>Sure, here are few published articles. <br /><a href="https://sathyasai.us/media/feb-2024/birthday-beanie-project-milwaukee-wi">Beanie Project</a>.<br />
                <a href="https://sathyasai.us/media/Jul-2020/highway-cleanup-milwaukee-wisconsin">Highway Cleanup</a> <br /> <a href="https://saiuniverse.sathyasai.org/2024/birthday-beanies-for-the-homeless-in-milwaukee-wisconsin/">Birthday Beanies for the Homeless</a></>
        }
    ];

    // Split into two groups
    const leftFaqs = faqData.slice(0, 5);
    const rightFaqs = faqData.slice(5);

    return (
        <section id="faq-1237">
            <div className="cs-container">
                <div className="cs-content">
                    <span className="cs-topper">Service Initiatives</span>
                    <h2 className="cs-title">Community Outreach Service</h2>
                </div>
                <div className="cs-wrapper">
                        <ul className="cs-faq-group">
                            {leftFaqs.map((item, idx) => (
                                <li
                                    className={`cs-faq-item${activeIndexes.includes(idx) ? ' active' : ''}`}
                                    key={idx}
                                >
                                    <button className="cs-button" onClick={() => handleToggle(idx)}>
                                        <span className="cs-number">{idx + 1}</span>
                                        <span className="cs-button-text">{item.question}</span>
                                    </button>
                                    {activeIndexes.includes(idx) && (
                                        <p className="cs-item-p">{item.answer}</p>
                                    )}
                                </li>
                            ))}
                        </ul>
                        <ul className="cs-faq-group">
                            {rightFaqs.map((item, idx) => (
                                <li
                                    className={`cs-faq-item${activeIndexes.includes(idx + 5) ? ' active' : ''}`}
                                    key={idx + 5}
                                >
                                    <button className="cs-button" onClick={() => handleToggle(idx + 5)}>
                                        <span className="cs-number">{idx + 6}</span>
                                        <span className="cs-button-text">{item.question}</span>
                                    </button>
                                    {activeIndexes.includes(idx + 5) && (
                                        <p className="cs-item-p">{item.answer}</p>
                                    )}
                                </li>
                            ))}
                        </ul>
                </div>
            </div>
        </section>
    );
}

export default ServiceFAQ;